import {
  RegulationViewModel,
  RegulationModel,
  RegulationFilterModel,
} from 'src/app/core/models/regulation';

import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { MatDialog } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { MasterHelper, Logger } from 'src/app/core/utilities';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { RegulationService } from 'src/app/core/services/regulation';
import { MatChipInputEvent } from '@angular/material/chips';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { UserProfile } from './../../../core/models/user/user-profile.model';
import { ItemIdModel } from 'src/app/core/models/filter-model/item-id-model';
import { BulkCloseModel } from 'src/app/core/models/regulation/bulk-close-model';
import { RegulationDetail } from 'src/app/core/models/regulation/regulation-detail';
//import { RegulatorStatusLabel } from 'src/app/core/enums/regulator/regulator-status';
import { UserManagementService } from './../../../core/services/user-management/user-management.service';
import { BulkCloseDialogComponent } from '../../distributed-ui-components/bulk-close-dialog/bulk-close-dialog.component';
import { ChangeViewerDialogComponent } from '../../distributed-ui-components/change-viewer-dialog/change-viewer-dialog.component';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
  selector: 'app-linked-updates',
  templateUrl: './linked-updates.component.html',
  styleUrls: ['./linked-updates.component.scss']
})

export class LinkedUpdatesComponent implements OnInit {

  @ViewChild(CdkVirtualScrollViewport)
  viewport!: CdkVirtualScrollViewport;

  @ViewChild('pubTypeSubAutocomplete')
  pubTypeSubAutocomplete!: MatAutocomplete;
  @ViewChild('pubTypeSubInput')
  pubTypeSubInput!: ElementRef<HTMLInputElement>;
  @ViewChild('topicSubInput')
  topicSubInput!: ElementRef<HTMLInputElement>;
  @ViewChild('pubTypeSubAutocomplete')
  topicSubAutocomplete!: MatAutocomplete;

  regulations: RegulationViewModel;
  allRegulations: RegulationModel[];
  isLoadingRegulations = false;
  isDownloading = false;
  isRegulationFetched = false;
  showMoreFilters = false;
  regulationFilter: RegulationFilterModel;
  currentPageNumber = 1;
  totalPageCount = 0;
  isLoadingPagination = false;
  endIndex = 0;
  selectable = true;
  removable = true;
  addOnBlur = true;
  myInnerHeight: any;
  toastModel: ToastViewModel;
  isToastShow = false;
  regulationDetail: RegulationDetail;
  selectedItemId: number;
  selectedItems: Array<number>;
  bulkCloseData: BulkCloseModel;
  pubTypeSubCntrl: FormControl = new FormControl();
  user: UserProfile;
  loggedInUser: UserProfile;
  userJurisdiction: ItemIdModel[] = [];

  selectedPubTypeSubFilters: string[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  searchedSubType: string[] = [];
  pubTypeSubFilters: string[] = [];
  searchedSubTopic: string[] = [];

  filterPersistenceKey = 'linkedUpdateFilter';
  @ViewChild('dropdown') filterDropDown: any;

  constructor(
    private regulationService: RegulationService,
    private sessionService: SessionService,
    private userService: UserManagementService,
    public dialog: MatDialog,
    private router: Router,
  ) {
    this.myInnerHeight = window.innerHeight - 220;
    this.loggedInUser = new UserProfile();
    this.regulations = new RegulationViewModel();
    this.allRegulations = new Array<RegulationModel>();
    this.regulationFilter = new RegulationFilterModel();
    this.user = new UserProfile();
    this.toastModel = new ToastViewModel();
    this.regulationDetail = new RegulationDetail();
    const persistFilter = JSON.parse(this.fetchFromBrowser(
      this.filterPersistenceKey
    ) as string) as RegulationFilterModel;
    if (persistFilter) {
      this.regulationFilter = persistFilter;
    }
    const url = this.router.url;
    this.regulationFilter.FilterType = url ? url === '/library/open-linked-updates' ? 'Open' : 'Actioned' : 'Open';
    this.selectedItemId = 0;
    this.selectedItems = [];
    this.bulkCloseData = new BulkCloseModel();
  }

  ngOnInit(): void {
    this.regulationFilter.SortKey = 'Date';
    this.getUserProfile();
  }

  getUserProfile(): void {
    this.sessionService.getLoginUserInfo().subscribe((user: UserProfile) => {
      this.user = user;
      if (this.user) {
        if (this.regulationFilter.ToDate) {
          this.getLinkedUpdates();
        } else {
          this.getLatestPublishedDate();
        }
        this.fetchUserJurisdiction();
      }
    });
  }

  getLatestPublishedDate(): void {
    this.regulationService.getPublishedDate().subscribe((date: any) => {
      this.regulationFilter.ToDate = this.regulationFilter.ToDate ? this.regulationFilter.ToDate : date.message;
      this.getLinkedUpdates();
    });
  }

  filterSubType(search: string): any {
    return this.searchedSubType.filter(option =>
      option.toLowerCase().includes(search.toLowerCase())
    );
  }

  filterSubTopic(search: string): any {
    return this.searchedSubTopic.filter(option =>
      option.toLowerCase().includes(search.toLowerCase())
    );
  }

  async getLinkedUpdates(): Promise<void> {
    const url = this.router.url;
    this.regulationFilter.FilterType = url ? url === '/library/open-linked-updates' ? 'Open' : 'Actioned' : 'Open';
    this.selectedPubTypeSubFilters = [];
    this.regulationFilter.UserId = this.user.userId;
    this.isLoadingRegulations = true;

    this.regulationService.getLinkedUpdates(this.regulationFilter).subscribe(
      (result: RegulationViewModel) => {
        this.regulations = result;
        this.allRegulations = result.data;
        if (this.regulationFilter.FilterType === 'Open') {
          this.sessionService.openLinkedUpdates = result.data.length;
        } else {
          this.sessionService.actionedLinkedUpdates = result.data.length;
        }

        if (this.regulations.data) {
          this.regulations.data.forEach((element: RegulationModel) => {
            element.date = MasterHelper.formatDate(
              element.date,
              'DD-MMM-YYYY'
            ).toString();
          });
        }
        this.searchedSubType = Array.from(new Set(result.data.map((item: any) => item.pubType))).filter(function (e) { return e; });
        this.pubTypeSubFilters = Array.from(new Set(result.data.map((item: any) => item.pubType))).filter(function (e) { return e; });
        this.endIndex = this.endIndex > this.regulations.totalCount ? this.regulations.totalCount : this.endIndex;
        this.isLoadingRegulations = false;
        this.isRegulationFetched = true;

        this.pubTypeSubCntrl.valueChanges.subscribe(term => {
          this.searchedSubType = term
            ? this.filterSubType(term)
            : this.pubTypeSubFilters;
        });
      },
      (error: HttpErrorResponse) => {
        this.isLoadingRegulations = false;
        Logger.log(this.constructor.name, error.error);
      }
    );
  }

  async downloadRegulations(): Promise<any> {
    const filter = MasterHelper.parseRegulationFilters(this.regulationFilter);
    this.isDownloading = true;
    this.regulationService.downloadRegulations(filter).subscribe(
      (data: any) => {
        this.isDownloading = false;
        const a = document.createElement('a'),
          fileURL = URL.createObjectURL(data);
        a.href = fileURL;
        a.download = `Regulations_${MasterHelper.getCurrrentDateTime(
          'MMDDYYYYHHMMSS'
        )}.xlsx`;
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
      },
      (error: HttpErrorResponse) => {
        this.isDownloading = false;
        Logger.log(this.constructor.name, error.error);
      }
    );
  }

  sortRegulations(key: string): void {
    this.regulationFilter.IsDesc = !this.regulationFilter.IsDesc;
    this.regulationFilter.SortKey = key;
    this.getLinkedUpdates();
  }

  OnFilter(filter: RegulationFilterModel): void {
    this.filterDropDown.hide();
    this.regulationFilter = filter;
    this.getLinkedUpdates();
  }

  calculatePagination(): void {
    if (this.regulationFilter.TakeCount) {
      const pageCount = Math.ceil(
        this.regulations.totalCount / this.regulationFilter.TakeCount
      );
      this.totalPageCount = pageCount;
    }
  }

  async OnAction(currentPageNumber: number): Promise<void> {
    this.currentPageNumber = currentPageNumber;
    this.regulationFilter.SkipCount = this.regulationFilter.TakeCount
      ? this.regulationFilter.TakeCount * (currentPageNumber - 1)
      : 0;
    await this.getLinkedUpdates();
  }

  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }

  removeFromBrowser(key: string): any {
    return localStorage.removeItem(key);
  }

  handler(): void {
    this.endIndex = this.viewport.getRenderedRange().end;
  }

  getFilteredRegulations(): void {
    this.regulations.data = this.allRegulations;
    this.regulations.totalCount = this.regulations.data.length;
    const searchedResult = Array<RegulationModel>();
    if (this.selectedPubTypeSubFilters.length > 0) {
      this.allRegulations.forEach(element => {
        this.selectedPubTypeSubFilters.forEach(element2 => {
          if (element.pubType.toUpperCase().includes(element2.toUpperCase())) {
            searchedResult.push(element);
          }
        });
      });
      this.regulations.data = searchedResult;
    }
    this.regulations.totalCount = this.regulations.data.length;
    this.endIndex = this.endIndex > this.regulations.totalCount ? this.regulations.totalCount : this.endIndex;
  }

  toggleClass(event: any, itemClass: string): void {
    if (event) {
      const hasClass = event.target.classList.contains(itemClass);
      if (hasClass) {
        event.target.classList = '';
      } else {
        event.target.classList = itemClass;
      }
    }
  }

  removeSubType(type: string): void {
    const index = (this.selectedPubTypeSubFilters).indexOf(
      type
    );

    if (index >= 0) {
      (this.selectedPubTypeSubFilters).splice(index, 1);
    }
    this.getFilteredRegulations();
  }

  addSubType(event: MatChipInputEvent): void {
    if (this.pubTypeSubAutocomplete && !this.pubTypeSubAutocomplete.isOpen) {
      const value = event.value;
      if ((value || '').trim()) {
        (this.selectedPubTypeSubFilters).push(value);
      }
      // Reset the input value
      event.chipInput!.clear();
      this.pubTypeSubCntrl.setValue(null);
      this.pubTypeSubCntrl.disable();
      this.pubTypeSubCntrl.enable();
      this.getFilteredRegulations();
    }
  }

  selectSubType(event: MatAutocompleteSelectedEvent): void {
    if (this.selectedPubTypeSubFilters) {
      this.selectedPubTypeSubFilters.push(event.option.viewValue);
    } else {
      this.selectedPubTypeSubFilters = [];
      this.selectedPubTypeSubFilters.push(event.option.viewValue);
    }
    this.pubTypeSubInput.nativeElement.value = '';
    this.pubTypeSubCntrl.setValue(null);
    this.pubTypeSubCntrl.disable();
    this.pubTypeSubCntrl.enable();
    this.getFilteredRegulations();
  }

  openDialog(item: RegulationModel): void {
    if (item.regulationDetails) {
      this.regulationDetail = item.regulationDetails;
    }
    this.regulationDetail.title = item.title;
    this.regulationDetail.type = item.pubType;
    this.regulationDetail.filterType = 'Linked Updates';
    const dialogRef = this.dialog.open(ChangeViewerDialogComponent, {
      width: '1000px',
      data: this.regulationDetail
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.updateRegulationDetail(result, item.id);
      } else {
        this.regulationDetail = new RegulationDetail();
      }
    });
  }

  updateRegulationDetail(regulation: RegulationDetail, id: number): void {
      this.selectedItems = [];
      this.isLoadingRegulations = true;
      regulation.regulationId = id;
      regulation.userId = this.user.externalUserId;
      regulation.isRead = true;
      regulation.status = +regulation.status;
      this.regulationService.updateRegulationInfo(regulation).subscribe(() => {
        this.selectedItems.push(id);
        this.alertMessage('success', 'Successfully updated');
        this.selectedItems = [];
        this.getLatestPublishedDate();
      });
    //}
  }

  // getRegulationStatus(num: number): any {
  //   return RegulatorStatusLabel.get(num);
  // }

  selectAllItem(event: any): void {
    if (event === 'Checked') {
      this.regulations.data.forEach(element => {
        this.selectedItems.push(element.id);
      });
    } else {
      this.selectedItems = [];
    }
  }

  selectItem(event: any, id: number): void {
    if (event === 'Checked') {
      this.selectedItems.push(id);
    } else {
      const index = (this.selectedItems as number[]).indexOf(id);
      if (index >= 0) {
        (this.selectedItems as number[]).splice(index, 1);
      }
    }
  }

  getSelectedItems(id: number): boolean {
    const index = (this.selectedItems as number[]).indexOf(id);
    return index >= 0 ? true : false;
  }

  bulkClose(): void {
    if (this.selectedItems.length > 0) {
      this.openBulkCloseDialog();
    } else {
      this.alertMessage('warning', 'Please select at least one');
    }
  }

  openBulkCloseDialog(): void {
    const dialogRef = this.dialog.open(BulkCloseDialogComponent, {
      width: '750px',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.bulkCloseRegulations(result);
      }
    });
  }

  bulkCloseRegulations(regDetails: RegulationDetail): void {
    this.isLoadingRegulations = true;
    this.bulkCloseData.itemIds = this.selectedItems;
    regDetails.userId = this.user.externalUserId;
    regDetails.isRead = true;
    this.bulkCloseData.regulationDetail = regDetails;
    this.regulationService.regulationBulkClose(this.bulkCloseData).subscribe((result: any) => {
      this.alertMessage('success', result.message);
      this.selectedItems = [];
      this.bulkCloseData = new BulkCloseModel();
      this.getLatestPublishedDate();
    });
  }

  alertMessage(type: string, message: string): void {
    if (type === 'success') {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
    }
    this.toastModel.Message = message;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3000);
  }

  deleteLinkedUpdates(): void {
    if (this.selectedItems.length > 0) {
      this.regulationService.removeLinkedUpdates(this.selectedItems).subscribe((data: any) => {
        this.selectedItems = [];
        this.getLinkedUpdates();
      });
    } else {
      this.alertMessage('warning', 'Please select at least one');
    }
  }

  fetchUserJurisdiction(): void {
    this.userService.getUserJurisdictions().subscribe((result: ItemIdModel[]) => {
      this.userJurisdiction = result;
    });
  }

  checkJurisdictionPermission(jurisdiction: string): boolean|undefined {
    if (jurisdiction) {
      const jurisArr = jurisdiction.split(',');
      const commonItems = new Array<string>();
      jurisArr.forEach((item) => {
        this.userJurisdiction.forEach((element2) => {
          if (item.toUpperCase() === element2.name.toUpperCase()) {
            commonItems.push(item);
          }
        });
      });
      return commonItems.length > 0 ? true : false;
    }
  }
}
